import { jsx as _jsx } from "react/jsx-runtime";
import CommonTabs from '../../../common_components/CommonTabs';
const TABS = [
    { value: 'meetings', label: 'Meetings' },
    { value: 'report', label: 'Score Report' },
];
/** The Meetings / Score Report switch — same tabs as Client Goal; the header's left side on both views. */
const ScorerTabs = ({ value, onChange }) => (_jsx(CommonTabs, { selectedValue: value, onChange: onChange, tabs: TABS }));
export default ScorerTabs;
